<template>
	<section>
		<!--工具条-->
		<el-col :span="24" style="padding-top:15px;padding-bottom:14px;border-bottom: 1px solid rgb(209, 219, 229);">
			<div>
				<el-tabs  >				
					<el-tab-pane  label="按时间" ></el-tab-pane>
			    </el-tabs>
				<label  style="width: 40px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">项目归属:</label>
				<el-input  placeholder="请选择项目" suffix-icon="el-icon-date" style="width: 140px" @focus="showProjectTree" v-model="projectNames"></el-input>
				<el-dialog  title="项目归属" v-model="projectTreeDialogVisible" >
				<div style="">
					<el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
					<el-tree class="filter-tree" :data="projectTree"  show-checkbox node-key="id" :default-checked-keys="projectTreeDefaultChecked" :filter-node-method="filterNode" ref="projectTree"></el-tree>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="projectTreeOnCancel">取 消</el-button>
					<el-button type="primary" @click="projectTreeOnSubmit">确 定</el-button>
				</div>
				</el-dialog>
				<label  style="width: 40px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">点名称:</label>
				<el-input style="width: 120px;" placeholder="请输入点名称" v-model="filterForm.deviceName">
				</el-input>
				<!-- <label  style="width: 40px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">点描述:</label>
				<el-input style="width: 120px;" placeholder="请输入点描述" v-model="filterForm.sn">
				</el-input> -->
				<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">类型:</label>
				<el-select  v-model="filterForm.fasType" placeholder="全部" style="width: 80px;">
					<el-option label="全部" value="all"></el-option>
					<el-option label="动作" value="action"></el-option>
					<el-option label="故障" value="abnormal"></el-option>
					<el-option label="屏蔽" value="isolation"></el-option>
				</el-select>
				<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">时间:</label>
				<div style="display:inline;">
					<el-date-picker :disabled="userRoleIdentity == 'level-untrue'" style="width:120px;" v-model="startMonth" value-format="yyyyMMdd"  format="yyyyMMdd" type="date" :placeholder="startMonthValue" @change="startMonthOnChange"></el-date-picker>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 6px 6px 6px 6px;box-sizing: border-box;">-</label>
					<el-date-picker :disabled="userRoleIdentity == 'level-untrue'" style="width:120px;" v-model="endMonth" value-format="yyyyMMdd" format="yyyyMMdd" type="date"  :placeholder="endMonthValue" @change="endMonthOnChange"></el-date-picker>
				</div>
				<el-button style="margin-left: 10px;" @click="queryBtn()">查询</el-button>
				<el-button @click="exportData">数据导出</el-button>
			</div>
		</el-col>

		<!--列表-->
		<el-table :data="list_data" size="mini" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="index" width="50">
			</el-table-column>
			<el-table-column prop="projectName" label="所属项目" width="120" sortable>
			</el-table-column>
			<el-table-column prop="deviceName" label="点名称" width="160" sortable>
			</el-table-column>
			<el-table-column prop="sn" label="点编号" width="160"  sortable>
			</el-table-column>
			<el-table-column prop="sysCodeName" label="子系统" min-width="140" sortable>
			</el-table-column>
			<el-table-column prop="cmptTypeName" label="点类型" width="100" sortable>
			</el-table-column>
			<el-table-column prop="deviceAddress" label="点地址" width="120" sortable>
			</el-table-column>
			<el-table-column prop="alarmTime" label="上报时间" width="150" sortable>
			</el-table-column>
			<el-table-column prop="alarmTypeName" label="数据类型" width="100" sortable>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="15" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		
	</section>
</template>

<script>
	import api from '@/api';
	import tools from '@/util/tools';
	import Treeselect from '@riophae/vue-treeselect'
	import global from '@/config/global_config'
	import Vue from 'vue'
	import router from '@/router/index.js'
	
	export default {
		components: { Treeselect },
		watch: {
			filterText(val) {
				this.$refs.projectTree.filter(val);
			}
        },
		data() {
			return {
				userRoleIdentity:global.getCurrentUser().roleIdentity,
				filters: {
					name: ''
				},
				list_data: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],
				cmptTypeList:[],
				editFormVisible: false,
				editLoading: false,
				saveFormRules: {
					name: [
						{ required: true, message: '点名称不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],  
					cmptType: [
						{ required: true, message: '请选择点类型'},
					],
					sn: [
						{ required: true, message: '点编号不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],
					address: [
						{ required: true, message: '点地址不能为空', trigger: 'blur' },
					],
					projectId:[
					    { required: true, message: '请选择所属项目'},
					],
					sysCode:[
					    { required: true, message: '请选择系统类型'},
					]
				},
				addForm: {

				},
				editForm: {

				},
				filterForm: {
					
				},
				sysAppList:[],
				projectSysSourceList_Original: [],
			    projectSysSourceList: [],
				addFormVisible: false,
				addLoading: false,
				businessGroupIdsSelect:'',
				sysSourceListVisible:false,
				projectTree:[],
				projectTreeDefaultChecked:[],
				filterText:'',
				projectTreeDialogVisible:false,
				projectNames:'',
				projectIds:'',
				shortAcountList:[],
				shortAcountList_tree:[],
				batchImportDialogVisible:false,
				search_word:'',
				bulidYear:'',
				catchTime:'',
				editSubmitButtonDisabled:false,
				addSubmitButtonDisabled:false,
				businessTypeList:[],
				regionAreaList:[],
				tableSelectionIds:'',
				filterCmptType:'',
				projectList:[],
				startMonth: '',
				endMonth:'',
				startMonthValue:'',
				//tools.getCurrentYear()+'01',
				endMonthValue:'',
				//tools.getCurrentYear()+'12',
			}
		},
		methods: {
			handleCurrentChange(val) {
				this.page = val;
				this.get_list_data();
			},
			startMonthOnChange(val) {  
				this.startMonthValue = val;  
			},
			endMonthOnChange(val) {  
				this.endMonthValue = val;
			},
			handleSearch(){
				this.get_list_data();
			},
			hiddenSysSourceList(){
				this.sysSourceListVisible = false;
			},
			showSysSourceList(){
				this.sysSourceListVisible = true;
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			showProjectTree(){
				this.projectTreeDialogVisible = true;
				return;
			},
			projectTreeOnCancel(){
				this.$refs.projectTree.setCheckedNodes([]);
				this.projectTreeDialogVisible = false;
			},
			projectTreeOnSubmit(){
				let leafCheckedNodes = [];
				let leafCheckedNodeNames = [];
				let checkedNodes = this.$refs.projectTree.getCheckedNodes();
				if(checkedNodes){
					checkedNodes.forEach(one => {
						if(!one.children){
							leafCheckedNodes.push(one.id);
							leafCheckedNodeNames.push(one.label);
						}
					});
					this.projectNames = leafCheckedNodeNames.join(',');
					this.projectIds =  leafCheckedNodes.join(',');
				}
				this.projectTreeDialogVisible = false;
			},
			get_list_data() {
				if((!tools.strIsEmpty(this.startMonthValue))&&(!tools.strIsEmpty(this.endMonthValue))){
					var starttime = Date.parse(new Date(this.startMonthValue.toString().substr(0,4),this.startMonthValue.toString().substr(4,2),this.startMonthValue.toString().substr(6,2)));
					var endtime = Date.parse(new Date(this.endMonthValue.toString().substr(0,4),this.endMonthValue.toString().substr(4,2),this.endMonthValue.toString().substr(6,2)));
					if(starttime>endtime){
						tools.error(new Vue(),"开始日期不能比结束日期大");
						return;
					}
					if((endtime - starttime) > (31536000000/12)){
						tools.error(new Vue(),"暂不支持超过一月范围的查询");
						return;
					}
				}
				let param = {
					deviceName:this.filterForm.deviceName,
					// sn:this.filterForm.sn,
					startYmd:this.startMonthValue,
					endYmd:this.endMonthValue,
					pageNum: this.page,
					pageSize: 15
				};
				if(null != this.projectIds && this.projectIds.length>0 )param.projectIds = this.projectIds;
				if(null != this.filterForm.fasType && this.filterForm.fasType.length>0) {
					if(this.filterForm.fasType == 'all')param.fasType = '';
					else param.fasType = this.filterForm.fasType;
				}
				if(null != this.filterForm.deviceName && this.filterForm.deviceName.length>0) param.deviceName = this.filterForm.deviceName;
				this.listLoading = true;
				api.fasData_getPageList_request(param).then((res) => {
					this.total = res.data.total;
					this.list_data = res.data.list;
					this.listLoading = false;
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
			},
			queryBtn(){
				let param = Object.assign({}, this.filterForm);
				if(null != param.search_word)this.search_word = param.search_word;
				if(null != param.projectIds)this.projectIds = param.projectIds;
				if(null != param.cmptType){
					if(param.cmptType == 'all')this.filterCmptType = '';
					else this.filterCmptType = param.cmptType;
				}
				this.get_list_data();
			},
			getProjectTree: function () {
				let param = {};
				this.listLoading = true;
				api.project_findByAccountIdList_request(param).then((res) => {
					let temp = [];
					this.projectList = [];
					if(res.data){
						for (let index = 0; index < res.data.length; index++) {
							temp[index] = {id:-res.data[index].groupId ,label:res.data[index].groupName,children:[]};
							res.data[index].projectList.forEach(one => {
								temp[index].children.push({id:parseInt(one.projectId),label:one.projectName});
								this.projectList.push({id:one.projectId,name:one.projectName});
							});
						}
					    console.log(temp);
					}
					this.projectTree = temp;
				}).catch(function (e) {
					console.log(e);
                });
				this.listLoading = false;
			},
			getShortAcountList: function (projectId) {
				let param = {projectId:projectId};//identity:'level-three',keys:''
				this.listLoading = true;
				api.project_getProjectAcountAble_request(param).then((res) => {
					let temp = [];
					for (let index = 0; index < res.data.length; index++) {
						temp[index] = {id:res.data[index].id ,label:res.data[index].code};
					}
					this.shortAcountList_tree = temp;
					this.shortAcountList = res.data;	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			selsChange: function (sels) {
				this.sels = sels;
				this.tableSelectionIds = "";
				this.sels.forEach(one => {
					if(this.tableSelectionIds.length == 0){
						this.tableSelectionIds = one.deviceId;
					}
					else
					this.tableSelectionIds = this.tableSelectionIds +","+one.deviceId;
				})
			},
			exportData:function () {
				let param = {
					deviceName:this.filterForm.deviceName,
					// sn:this.filterForm.sn,
					startYmd:this.startMonthValue,
					endYmd:this.endMonthValue,
				};
				if(null != this.projectIds && this.projectIds.length>0 )param.projectIds = this.projectIds;
				if(null != this.filterForm.fasType && this.filterForm.fasType.length>0) {
					if(this.filterForm.fasType == 'all')param.fasType = '';
					else param.fasType = this.filterForm.fasType;
				}
				if(null != this.filterForm.deviceName && this.filterForm.deviceName.length>0) param.deviceName = this.filterForm.deviceName;
				this.listLoading = true;
				api.fasData_exportData_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'firedataList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			bulidYearOnChange(val) {  
				this.bulidYear = val;
				if(this.editFormVisible) this.editForm.bulidYear =val;
				else this.addForm.bulidYear =val;
			},
			catchTimeOnChange(val) {  
				this.catchTime = val;
				if(this.editFormVisible) this.editForm.catchTime =val;
				else this.addForm.catchTime =val;
			},
			updateAcountListTreeValue(state, value){
				state.value = value
			},
			cancelAddSubmit(){
				this.addFormVisible = false;
				this.$refs.addForm.resetFields();
				if(this.addSubmitButtonDisabled)this.addSubmitButtonDisabled = false;
			},
			getRegionAreaList: function (query) {
				console.log(query)
				let param = {keys:query};
				this.listLoading = true;
				api.account_getRegionAreaList_request(param).then((res) => {
					if(res.data){
						this.regionAreaList = res.data;
					}
				}).catch(function (e) {
					console.log(e);
				});
				this.listLoading = false;
			}
		},
		mounted() {
			this.get_list_data();
			this.getProjectTree();
			this.getShortAcountList(null);
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// firedata_list.vue?5cde1c20